import toptal from "../../assets/img/job/toptal.webp";
import upwork from "../../assets/img/job/upwork.webp";
import linkedin from "../../assets/img/job/linkedin.webp";
import freelancer from "../../assets/img/job/freelancer.webp";
import malt from "../../assets/img/job/malt.webp";
import peopleperhour from "../../assets/img/job/peopleperhour.webp";
import simplyhired from "../../assets/img/job/simplyhired.webp";
import guru from "../../assets/img/job/guru.webp";
import fiverr from "../../assets/img/job/fiverr.webp";
import nomads from "../../assets/img/job/nomads.webp";

export const DataJob = [
  {
    title: "Toptal",
    path: "https://www.toptal.com/",
    cName: "icon",
    icon: toptal,
    description:
      "Toptal is an exclusive network of the top freelance software developers, designers, finance experts, product managers, and project managers in the world. Top companies hire Toptal freelancers for their most important projects.",
  },
  {
    title: "UpWork",
    path: "https://www.upwork.com/",
    cName: "icon",
    icon: upwork,
    description:
      "In-demand talent on demand. Upwork is how.Hire proven pros with confidence using the world’s largest, remote talent platform.",
  },
  {
    title: "LinkedIn",
    path: "https://www.linkedin.com/",
    cName: "icon",
    icon: linkedin,
    description:
      "I think everyone know LinkedIn. It's the facebook for finding a job, create a good profile and show what you can do to the companies. ",
  },
  {
    title: "Freelancer",
    path: "https://www.freelancer.com/",
    cName: "icon",
    icon: freelancer,
    description:
      "Browse portfolios, View bids, Live chat, Pay for quality, Track progress, 24/7 support.",
  },
  {
    title: "Malt",
    path: "https://www.malt.com/",
    cName: "icon",
    icon: malt,
    description:
      "Are you a freelancer? Live freelancing how you imagined it. Jobs you choose from over 30,000 clients. A simple and secure service: less administration - payment within 48 hours.Support from a community of experts",
  },
  {
    title: "Peopleperhour",
    path: "https://www.peopleperhour.com/",
    cName: "icon",
    icon: peopleperhour,
    description:
      "Hire in minutes. Pay per hour. PeoplePerHour connects your business to an international community of freelancers who want nothing more than to help your business succeed. Discover rated and reviewed experts for every skill imaginable — One discovery could change your business forever.",
  },
  {
    title: "SimplyHired",
    path: "https://www.simplyhired.com/",
    cName: "icon",
    icon: simplyhired,
    description:
      "Free online resume builder. Create a professional resume in minutes. Choose from a library of 30+ free resume templates and samples of career-specific writing examples. Browse SimplyHired for jobs, view local and national salary information, discover companies, and learn about the job market in a specific city.",
  },
  {
    title: "Guru",
    path: "https://www.guru.com/",
    cName: "icon",
    icon: guru,
    description:
      "Find top Freelancers, 800 000 employers worldwide, 1 million paid invoices, $250 Million paid to Freelancers, 99% customer satisfaction rate.",
  },
  {
    title: "Fiverr",
    path: "https://www.fiverr.com/",
    cName: "icon",
    icon: fiverr,
    description:
      "Set up your Gig, and offer your work to our global audience. Get notified when you get an order and use our system to discuss details with customers. Get paid on time, every time. Payment is transferred to you upon order completion.",
  },
  {
    title: "6nomads",
    path: "https://6nomads.com/",
    cName: "icon",
    icon: nomads,
    description:
      "6nomads is a remote-focused job platform for tech talent. Create a profile and let companies apply to you.",
  },
];
